module.exports = __webpack_public_path__ + "img/chain08.4bcaa45b.png";